import { render, staticRenderFns } from "./TourAccomodationRooms.vue?vue&type=template&id=fcafac02&scoped=true&"
import script from "./TourAccomodationRooms.vue?vue&type=script&lang=js&"
export * from "./TourAccomodationRooms.vue?vue&type=script&lang=js&"
import style0 from "./TourAccomodationRooms.vue?vue&type=style&index=0&id=fcafac02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcafac02",
  null
  
)

export default component.exports